<wa-card>
  <div class="wa-stack">
    <div><h5>{{ exam.module.name }}</h5></div>
    <div class="wa-split wa-align-items-start wa-gap-xl">
      <div class="wa-stack">
        <div>{{ exam.module.code }}
          @if (has_retake()) {
            <wa-badge appearance="filled outlined" pill variant="neutral">
              <wa-icon label="retake exam" name="recycle"></wa-icon>
            </wa-badge>
          }
        </div>
        <div>Examiner (tbd)</div>
        <div>Organizer (tbd)</div>
      </div>
      <div class="wa-stack">
        <h6>Main Exam</h6>
        <div class="wa-cluster">
          <wa-icon name="calendar" variant="solid"></wa-icon>
          <span>{{ exam.main_exam.begin | date: dateFormat }}, {{ exam.main_exam.begin | date: timeFormat }} - {{ exam.main_exam.end | date: timeFormat }}</span>
        </div>
        <div class="wa-cluster">
          <wa-icon name="location-dot" variant="solid"></wa-icon>
          @if (!locationNames.size) {
            <span>???</span>
          } @else {
            @for (locationName of locationNames; track locationName) {
              <span>{{ locationName }}</span>
              @if (!$last) {
                <span>, </span>
              }
            }
          }
        </div>
        <div class="wa-cluster">
          <wa-icon name="buildings" variant="regular"></wa-icon>
          <span>{{ exam.rooms.length }}</span>
        </div>
        <div class="wa-cluster">
          <wa-icon name="people" variant="solid"></wa-icon>
          <span>{{ exam.main_exam.participants }}</span>
        </div>
      </div>
      <div class="wa-stack">
        <h6>Retake Exam</h6>
        @if (!has_retake()) {
          <div>---</div>
        } @else {
          <div class="wa-cluster">
            <wa-icon name="calendar" variant="solid"></wa-icon>
            <span>{{ $safeNavigationMigration(exam.retake_exam?.begin) | date: dateFormat }}, {{ $safeNavigationMigration(exam.retake_exam?.begin) | date: timeFormat }} - {{ $safeNavigationMigration(exam.retake_exam?.end) | date: timeFormat }}</span>
          </div>
          <div class="wa-cluster">
            <wa-icon name="location-dot" variant="solid"></wa-icon>
            @if (!locationNames.size) {
              <span>???</span>
            } @else {
              @for (locationName of locationNames; track locationName) {
                <span>{{ locationName }}</span>
                @if (!$last) {
                  <span>, </span>
                }
              }
            }
          </div>
          <div class="wa-cluster">
            <wa-icon name="buildings" variant="regular"></wa-icon>
            <span>{{ exam.rooms.length }}</span>
          </div>
          <div class="wa-cluster">
            <wa-icon name="people" variant="solid"></wa-icon>
            <span>{{ exam.retake_exam?.participants }}</span>
          </div>
        }
      </div>
    </div>
    <div class="wa-cluster wa-gap-3xl wa-justify-content-end">
      @if (exam.suggested_supervision_count + exam.supervision_count >=  exam.main_exam.required_supervisors + (exam.retake_exam?.required_supervisors || 0)) {
        <wa-tag variant="success"><wa-icon name="person-chalkboard" variant="solid"></wa-icon>
          <span>supervision: {{ exam.suggested_supervision_count + exam.supervision_count }} / {{ exam.main_exam.required_supervisors + (exam.retake_exam?.required_supervisors || 0) }}</span></wa-tag>
      } @else {
        <wa-tag variant="danger"><wa-icon name="person-chalkboard" variant="solid"></wa-icon>
          <span>supervision: {{ exam.suggested_supervision_count + exam.supervision_count }} / {{ exam.main_exam.required_supervisors + (exam.retake_exam?.required_supervisors || 0) }}</span></wa-tag>
      }
      @if (exam.suggested_correction_sum + exam.correction_sum  >= exam.main_exam.required_corrections + (exam.retake_exam?.required_corrections || 0)) {
        <wa-tag variant="success">
          <wa-icon name="pen-nib" variant="solid"></wa-icon>
          <span>grading: {{ exam.suggested_correction_sum + exam.correction_sum }} / {{ exam.main_exam.required_corrections + (exam.retake_exam?.required_corrections || 0) }}</span>
        </wa-tag>
      } @else {
       <wa-tag variant="danger">
          <wa-icon name="pen-nib" variant="solid"></wa-icon>
          <span>grading: {{ exam.suggested_correction_sum + exam.correction_sum }} / {{ exam.main_exam.required_corrections + (exam.retake_exam?.required_corrections || 0) }}</span>
        </wa-tag>
      }
      </div>
    <div class="wa-cluster wa-gap-xs wa-justify-content-end">
      @if (showControls()) {
        <wa-button (click)="editSupervisions.emit(exam)" appearance="filled" size="s" variant="neutral">
          <wa-icon label="edit supervision" name="person-chalkboard" slot="end"></wa-icon>
          supervision
        </wa-button>
        <wa-button (click)="editCorrections.emit(exam)" appearance="filled" size="s" variant="neutral">
          <wa-icon label="edit corrections" name="pen-nib" slot="end"></wa-icon>
          grading
        </wa-button>
      }
    </div>
  </div>
</wa-card>
